import React, { useState, useEffect } from 'react';
import * as Styles from './ModalAccessN8n.style';
import withErrorBoundary from '@/utils/errorBoundary';
import { Modal, TextField } from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';

const ModalAccessN8n = ({ modalN8nLocale, n8nState, handleClose }) => {
  const [copiedField, setCopiedField] = useState(null);

  const fields = [
    {
      name: 'fieldIp',
      label: modalN8nLocale.labels.ip,
      type: 'text',
      value: n8nState.data && n8nState.data.ip,
    },
    {
      name: 'fieldPort',
      label: modalN8nLocale.labels.port,
      type: 'text',
      value: n8nState.data && n8nState.data.port,
    },
    {
      name: 'fieldUser',
      label: modalN8nLocale.labels.user,
      type: 'password',
      value: n8nState.data && n8nState.data.user,
    },
  ];

  const handleClickIcon = (value, name) => {
    const toggleIcon = (name) => {
      setCopiedField(name);
      setTimeout(() => setCopiedField(null), 2000);
    };

    if (navigator.clipboard && window.isSecureContext) {
      toggleIcon(name);
      return navigator.clipboard.writeText(value);
    }

    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      toggleIcon(name);
      const result = document.execCommand('copy');
      document.body.removeChild(textarea);
      return result ? Promise.resolve() : Promise.reject();
    } catch (error) {
      document.body.removeChild(textarea);
      return Promise.reject();
    }
  };

  const enableReadonly = () => {
    const rows = document.querySelectorAll('[data-testid^="row-"]');
    rows.forEach((row) => {
      const inputs = row.querySelectorAll('input');
      inputs.forEach((input) => {
        input.setAttribute('readonly', true);
      });
    });
  };

  useEffect(() => {
    enableReadonly();
  }, []);

  const modalHeader = () => (
    <Styles.ModalHeader>
      <Styles.Title>{modalN8nLocale.title}</Styles.Title>
      <Styles.Subtitle>{modalN8nLocale.subtitle}</Styles.Subtitle>
    </Styles.ModalHeader>
  );

  return (
    <Modal
      onClose={() => handleClose()}
      maxWidth={516}
      testId="Modal"
      title={modalHeader()}
    >
      <Styles.ModalContent>
        <Styles.ContentList>
          <Styles.ContentItem>
            <Styles.ContentTitle>{modalN8nLocale.step1Title}</Styles.ContentTitle>
            <Styles.ContentDesc>{modalN8nLocale.step1Subtitle}</Styles.ContentDesc>
          </Styles.ContentItem>

          <Styles.ContentItem>
            <Styles.ContentTitle>{modalN8nLocale.step2Title}</Styles.ContentTitle>

            <Styles.WrapperTextField>
              {fields.map(field => (
                <Styles.Row key={field.name} data-testid={`row-${field.name}`}>
                  <Styles.Label locale={isBRServer ? 'br' : 'es'}>{field.label}</Styles.Label>

                  <Styles.WrapperField locale={isBRServer ? 'br' : 'es'}>
                    <TextField
                      label=""
                      maxLength={100}
                      name={field.name}
                      testId={field.name}
                      leadingIcon={copiedField === field.name ? 'IconCheck' : 'IconCopy'}
                      type={field.type}
                      value={field.value}
                      onClickIcon={() => handleClickIcon(field.value, field.name)}
                    />
                  </Styles.WrapperField>
                </Styles.Row>
              ))}
            </Styles.WrapperTextField>
          </Styles.ContentItem>
        </Styles.ContentList>
      </Styles.ModalContent>
    </Modal>
  );
};

export default withErrorBoundary(ModalAccessN8n, 'ModalAccessN8n');
